import { FilmTile } from "@components/film/FilmTile"
import { Button } from "@components/ui/Button"
import { filmsWithSessions } from "@hooks/useFilmSearch"
import { tv } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Film List",
  description: "A grid of film tiles — either individual sessions, or whole films",
  category: "media",
  tags: ["subpage", "homepage-root"],
  icon: "editor-video",
  keywords: ["film grid slider"],
  flags: {
    fullWidth: true,
  },
}

export default defineBlock("content/film-list", (props) => {
  const styles = createStyles()

  const items =
    props.customFilmSelection && props.customFilmSelection.length > 0
      ? filmsWithSessions(props.customFilmSelection)
          .filter((film, ix, self) => ix === self.findIndex((t) => t.film?.title === film.film?.title))
          .map((film) => {
            return { film: film.film, session: props.customFilmSelectionSessions ? film.session : undefined }
          })
      : props.filmQuery?.items

  return (
    <div className={styles.wrapper()}>
      {/* Heading/CTA */}
      <div className="flex justify-between items-center mb-7 md:mb-4">
        <EditableText
          store="title"
          as="h4"
          className="type-title-s uppercase"
          placeholder="Films"
          defaultValue="Films"
          plainText
        />
        <Button
          href={props.viewAllLink?.url || "/browse"}
          target={props.viewAllLink?.target || undefined}
          variant="link"
        >
          <EditableText store="cta" as="span" placeholder="View all" defaultValue="View all" plainText />
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-7 md:gap-4">
        {/* Film tiles */}
        {items?.map((item, i) => (
          <div key={i} className={styles.item()}>
            <FilmTile film={item.film} session={item.session ?? undefined} />
          </div>
        ))}
      </div>
    </div>
  )
})

const createStyles = tv({
  slots: {
    wrapper: "p-4 my-10",
    item: "col-span-1",
  },
})
